<template>
  <div class="contact-us">
    <div class="product animated-fadeInUp" data-wow-delay="0.4s" style="animation-name: fadeInUp;">
      <div class="product-cont">
        <div class="product-box">
          <div class="contact-us-box">
            <div class="contact-us-map">
              <div class="contact-us-map-bg">
                <img src="../../../../static/image/contact-bg.png" alt="">
              </div>
              <img class="left_location" src="../../../../static/image/location.png" @click="getChinese" alt="">
              <img class="right-locatuon" src="../../../../static/image/location.png" @click="getEnglish" alt="">
            </div>
            <div class="contact-us-bottom">
              <div class="left">
                <div class="contact-us-title">
                  {{ title }}
                </div>
                <div class="left-line"></div>
                <div class="contact-us-content">{{ info[0].address }}</div>
                <div class="service">
                  <div class="service-box">
                    <!-- <div class="service-title"> {{ info[0].title }}:</div> -->
                    <div class="service-box-cont">
                      <div class="Email service-box-item">
                        <img src="../../../../static/image/email_.png" alt="">
                        <p> 邮箱：{{ info[0].email }}</p>
                      </div>
                      <div class="phone service-box-item">
                        <img src="../../../../static/image/phone.png" alt="">
                        <p>电话：{{info[0].tel}}</p>
                      </div>
                    </div>

                  </div>
                  <!-- <div class="service-box">
                    <div class="service-title"> {{ info[1].title }}:</div>
                    <div class="service-box-cont">
                      <div class="Email service-box-item">
                        <img src="../../../../static/image/email_.png" alt="">
                        <p> Email:{{ info[1].email }}</p>
                      </div>
                      <div class="phone service-box-item">
                        <img src="../../../../static/image/phone.png" alt="">
                        <p>Telephone:{{ info[1].tel }}</p>
                      </div>
                    </div>

                  </div> -->
                </div>
              </div>
              <div class="right" v-if="isMap">
                <!-- <amap ref="map" cache-key="coord-picker-map" style="height:248px" mmap-style="amap://styles/whitesmoke"
                  async :center="cn_center" :zoom="zoom" is-hotspot>
                   <el-amap-marker vid="component-marker" :position="cn_center"></el-amap-marker>
                </amap> -->
                <el-amap vid="amap" :zoom="zoom" class="amap-demo" style="height:248px" :center="cn_center" id="map">
                  <el-amap-marker vid="component-marker" :position="cn_center"></el-amap-marker>
                </el-amap>
              </div>
              <div class="right" v-else>
                <!-- <amap ref="map" cache-key="coord-picker-map" style="height:248px" mmap-style="amap://styles/whitesmoke"
                  async :center.sync="en_center" :zoom.sync="zoom" is-hotspot>
                </amap> -->
                <el-amap vid="amap" :zoom="zoom" class="amap-demo" style="height:248px" :center="en_center" id="map">
                  <el-amap-marker vid="component-marker" :position="en_center"></el-amap-marker>
                </el-amap>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { aboutContact } from '@/request/api'
export default {
  props: {
    productId: {
      typeof: String,
      required: true,

    },
    title: {
      typeof: String,
      required: true,

    }
  },
  data() {
    return {
      info: [],
      contactIndex: 0,
      zoom: 30,
      cn_center: [116.229732, 40.073623],
      en_center: [120.495375, 31.364684],
      markers: [
        {
          position: [121.5273285, 31.21515044],
          events: {
            click: () => {
              alert('click marker');
            },
            dragend: (e) => {
              this.markers[0].position = [e.lnglat.lng, e.lnglat.lat];
            }
          },
          visible: true,
          draggable: false,
          template: '<span>1</span>',
        }
      ],
      locationInfo: {},
      isMap: true
    }
  },
  created() {
    this.locationInfo = JSON.parse(localStorage.getItem("info"))
    this.cn_center[0] = this.locationInfo['longitude_cn'].desc
    this.cn_center[1] = this.locationInfo['latitude_cn'].desc
    this.en_center[0] = this.locationInfo['longitude_en'].desc
    this.en_center[1] = this.locationInfo['latitude_en'].desc
    if (localStorage.getItem('language') == 'Chinese') {
      this.isMap = true
    } else {
      this.isMap = false
    }
  },
  mounted() {
    this.getContact()
    new AMap.Map('container', {
      viewMode: '2D', // 默认使用 2D 模式，如果希望使用带有俯仰角的 3D 模式，请设置 viewMode: '3D'
      zoom: 11, // 初始化地图层级
      center: [116.397428, 39.90923] // 初始化地图中心点
    });
  },
  methods: {
    getContact() {
      aboutContact({}).then(res => {
        this.info = res.data[20]
      })
    },
    getChinese() {
      this.isMap = true
    },
    getEnglish() {
      this.isMap = false
    },
  }
}
</script>
<style lang="scss" scoped>
.contact-us-box {
  margin-top: 20px;
  position: relative;

  .contact-us-map {
    width: 100%;
    position: relative;

    .contact-us-map-bg {
      img {
        width: 100%;
      }
    }

    .left_location {
      position: absolute;
      cursor: pointer;
      top: 31%;
      left: 17%;
      width: 42.92px;
    }

    .right-locatuon {
      cursor: pointer;
      position: absolute;
      top: 39%;
      right: 20%;
      width: 42.92px;
    }
  }

  .contact-us-bottom {
    position: relative;
    margin-top: -282px;
    background: #FFFFFF;
    background-image: url('../../../../static/image/contact-us-bg.png');
    padding: 54px 75px 40px 75px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      width: 60%;

      .contact-us-title {
        font-size: 24px;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        color: #333333;
      }

      .left-line {
        margin-top: 17px;
        width: 65px;
        height: 4px;
        background: #DB2733;
      }

      .contact-us-content {
        margin-top: 39px;
        font-size: 20px;

        color: #333333;
      }

      .service {
        // margin-top: 39px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .service-box {
          width: 50%;

          .service-title {
            font-size: 16px;

            font-weight: 400;
            color: #333333;
          }

          .service-box-cont {
            margin-top: 17px;
          }

          .service-box-item {
            margin-bottom: 14px;
            display: flex;
            align-items: center;
            font-size: 15px;

            color: #666666;

            p {
              margin-left: 11px;
            }
          }
        }
      }
    }

    .right {
      width: 40%;
      min-height: 248px;

      >>>.el-vue-amap-containe {
        width: 100% !important;
        height: 100% !important;
      }
    }
  }
}

@media screen and (max-width:767px) {
  .contact-us-bottom {
    margin-top: -71px !important;
    padding: 30px !important;
    display: block !important;

    .left {
      width: 100% !important;
    }

    .right {
      margin-top: 30px;
      width: 100% !important;
    }
  }

  .service {
    display: block !important;

    .service-box {
      width: 100% !important;
    }
  }

  .left_location {
    position: absolute;
    cursor: pointer;
    top: 31%;
    left: 17%;
    width: 20px !important;
  }

  .right-locatuon {
    position: absolute;
    top: 36% !important;
    right: 20%;
    width: 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/aboutUs/components/contactus.vue